import Vue from 'vue'
import Component from 'vue-class-component'

import { ConfigLanguage, VueFire } from '@codee-club/common/dist/dao'

import { GoogleSignInButton } from '@/views'

@Component({ components: { GoogleSignInButton } })
export default class Landing extends Vue {
  get languages(): Array<VueFire<ConfigLanguage>> {
    return this.$store.getters.allLanguages
  }
}
